import z from "zod";

const licenseReasonDataSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    reason: z.string(),
});

const licenseUserDataSchema = z.object({
    ip: z.string(),
    code: z.string(),
    chargeId: z.string(),
    deviceSerial: z.string(),
    user: z.string(),
});

const licenseMovedSchema = z.object({
    ip: z.string().optional(),
    code: z.string().optional(),
    chargeId: z.string().optional(),
    deviceSerial: z.string().optional(),
    group: z.object({ old: z.number(), new: z.number() }),
});

export { licenseMovedSchema, licenseReasonDataSchema, licenseUserDataSchema };
